export default (axios) => ({
  getCbsPayDirectData(queryString) {
    return axios.get("/cbs_paydirects", {
      params: queryString
    })
  }
})